const SET_USER_ID = (state, payload) => {
    state.user_id = payload
}
const SET_FAV_COUNT = (state, payload) => {
    state.favcount = payload.favcount
    state.comparecount = payload.comparecount
}
const SET_COMPARE_INFO = (state, payload) => {
    state.compareinfo = payload
    state.comparecount = payload.totalcount;
}
const SET_FIRMS = (state, payload) => {
    state.firms = payload
    const default_firm = payload.filter(firm => firm.default_firm === 1)

    if(default_firm.length) {
        state.firm_default_id = default_firm[0].id;
    }
}
const SET_VALIDATION = (state, payload) => {
    state.validation[payload.form] = payload.data
}

const RESET_VALIDATION = (state, payload) => {
    state.validation[payload] = {}
}

const SET_MESSAGE = (state, payload) => {
    state.message = payload
}
export default {
    SET_USER_ID,
    SET_FAV_COUNT,
    SET_COMPARE_INFO,
    SET_FIRMS,
    SET_VALIDATION,
    RESET_VALIDATION,
    SET_MESSAGE
}
